import { useEffect, useState } from "react";
import { useLoader } from "../useLoader";
import ApiService from "../../services/ApiServiceClass";
import { slipChartData } from "../../data/slipChartData";


export const useGetRequestForSlipChart = () => {
    const [chatData, setChartData] = useState<any[]>([]);
    const loader = useLoader();

    const fetchChartData = async () => {
        loader?.setIsLoading(true);
        try {
            const responseData = await ApiService.getRequestForSlipchart();
            setChartData(responseData.data);
            loader?.setIsLoading(false);
            return responseData.data;            
        } catch(error) {
            loader?.setIsLoading(false);
            throw(error);
        }
    }

    useEffect(() => {
        fetchChartData();
    }, []);
        
    return {chatData, setChartData, fetchChartData}
}